<template>
<div>
    <div :class="containerCSSClass" :id="containerID" v-show="!showLoadingButton"></div>
    <div :class="fakebuttonCSSClass" v-show="showLoadingButton">{{ resources.processingPayment }}</div>
</div>

</template>

<script src='./paypal-place-order-button.js'></script>
